/**
 * colorPalettes.ts — Single source of truth for frontend color values.
 * v3.42 - 2026-02-24 - Extracted from KNOWLEDGE_MAP_COLOR_RULES.md (ADR-002)
 *
 * When the knowledge map changes, update this file. chartMapper.ts imports
 * from here — it never defines its own color constants.
 */

// v3.42 - Knowledge Map §2 Financial Polarity (lines 131-145) + §6 Dark Mode (lines 489-491)
// v3.42 - Knowledge Map §1 Qualitative (lines 112-113) + existing WCAG-tuned dark variants (v3.38)
export const PALETTES = {
  financialPolarity: {
    light: { positive: '#2E7D32', negative: '#C62828', neutral: '#616161' },
    dark:  { positive: '#66BB6A', negative: '#EF5350', neutral: '#9E9E9E' },
  },
  qualitative: {
    light: ['#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F', '#EDC948'],
    dark:  ['#7BA4D4', '#F5A854', '#E87A7C', '#96D0CB', '#7BBF72', '#F2D86E'],
  },
  // Add more palette types here as the knowledge map grows:
  // severityGradient, sequential, statusTraffic, periodComparison, etc.
};
